// @flow
import * as React from "react";

import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import Header from "./Header";
import Footer from "./Footer";
import Container from "./Container";
import PushNotifications from "./PushNotifications";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App(): React.Node {
  return (
    <>
      <Header />
      <PushNotifications />
      <QueryClientProvider client={queryClient}>
        <Container />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
      <Footer />
    </>
  );
}

export default App;
